/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlEntityStatsVulnerabilityCategoriesCount
 */
export interface ControlEntityStatsVulnerabilityCategoriesCount {
    /**
     * 
     * @type {number}
     * @memberof ControlEntityStatsVulnerabilityCategoriesCount
     */
    ssl: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityStatsVulnerabilityCategoriesCount
     */
    encryption: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityStatsVulnerabilityCategoriesCount
     */
    web: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityStatsVulnerabilityCategoriesCount
     */
    remote: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityStatsVulnerabilityCategoriesCount
     */
    storage: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityStatsVulnerabilityCategoriesCount
     */
    eol: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityStatsVulnerabilityCategoriesCount
     */
    cve: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityStatsVulnerabilityCategoriesCount
     */
    dns: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityStatsVulnerabilityCategoriesCount
     */
    token: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityStatsVulnerabilityCategoriesCount
     */
    exposure: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityStatsVulnerabilityCategoriesCount
     */
    other: number;
}

/**
 * Check if a given object implements the ControlEntityStatsVulnerabilityCategoriesCount interface.
 */
export function instanceOfControlEntityStatsVulnerabilityCategoriesCount(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "ssl" in value;
    isInstance = isInstance && "encryption" in value;
    isInstance = isInstance && "web" in value;
    isInstance = isInstance && "remote" in value;
    isInstance = isInstance && "storage" in value;
    isInstance = isInstance && "eol" in value;
    isInstance = isInstance && "cve" in value;
    isInstance = isInstance && "dns" in value;
    isInstance = isInstance && "token" in value;
    isInstance = isInstance && "exposure" in value;
    isInstance = isInstance && "other" in value;

    return isInstance;
}

export function ControlEntityStatsVulnerabilityCategoriesCountFromJSON(json: any): ControlEntityStatsVulnerabilityCategoriesCount {
    return ControlEntityStatsVulnerabilityCategoriesCountFromJSONTyped(json, false);
}

export function ControlEntityStatsVulnerabilityCategoriesCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityStatsVulnerabilityCategoriesCount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ssl': json['ssl'],
        'encryption': json['encryption'],
        'web': json['web'],
        'remote': json['remote'],
        'storage': json['storage'],
        'eol': json['eol'],
        'cve': json['cve'],
        'dns': json['dns'],
        'token': json['token'],
        'exposure': json['exposure'],
        'other': json['other'],
    };
}

export function ControlEntityStatsVulnerabilityCategoriesCountToJSON(value?: ControlEntityStatsVulnerabilityCategoriesCount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ssl': value.ssl,
        'encryption': value.encryption,
        'web': value.web,
        'remote': value.remote,
        'storage': value.storage,
        'eol': value.eol,
        'cve': value.cve,
        'dns': value.dns,
        'token': value.token,
        'exposure': value.exposure,
        'other': value.other,
    };
}

